export interface SlashCommand {
  name: string;
  description: string;
}

export const SLASH_COMMANDS: SlashCommand[] = [
  { name: 'guide', description: 'Show everything Max can do' },
  { name: 'skills', description: 'List or import skills from skills.sh' },
  { name: 'model', description: 'Switch LLM provider and model' },
  { name: 'search', description: 'Choose preferred web search provider' },
  { name: 'keys', description: 'Manage stored API keys' },
  { name: 'factory-reset', description: 'Reset Max settings, credentials, or all data' },
  { name: 'gateway', description: 'Connect Max to WhatsApp' },
  { name: 'rules', description: 'Show your research rules' },
  { name: 'clear', description: 'Clear the conversation' },
  { name: 'memory', description: 'Show what Max remembers about you' },
  { name: 'heartbeat', description: 'Show your heartbeat monitoring checklist' },
  { name: 'history', description: 'Show recent conversation summaries' },
  { name: 'help', description: 'Show keyboard shortcuts and tips' },
];

/**
 * Filter commands matching the current input.
 * Input should start with "/". Bare "/" returns all commands.
 */
export function matchCommands(input: string): SlashCommand[] {
  const query = input.slice(1).toLowerCase();
  if (query === '') return SLASH_COMMANDS;
  return SLASH_COMMANDS.filter(cmd => cmd.name.startsWith(query));
}
